<template>
  <div class="countdown-body">
    <div class="bk-img"></div>
    <div
        class="wrapper"
        :style="{
        opacity: wrapperOpacity,
        background: 'rgba(255,255,255,0.08)',
        backdropFilter: 'blur(18px)',
        boxShadow: '0 8px 40px 8px #f26aff40, 0 0 16px 4px #7d6fff40'
      }"
    >
      <h1 class="heading">Rebit 2.2 · BitYuan</h1>
      <h1
          class="heading heading-gradient"
          id="tuned"
          :style="{
          opacity: wrapperOpacity,
          paddingTop: '20px'
        }"
      >
        {{ headingText }}
      </h1>

      <div id="js-clock" class="js-clock" :style="{ opacity: wrapperOpacity }">
        <div
            v-for="(box, index) in timeBoxes"
            :key="index"
            :class="`box box-${index + 1}`"
            :style="{ opacity: wrapperOpacity }"
        >
          <div :id="box.id" class="clock-number">{{ box.value }}</div>
          <div class="clock-label">{{ box.label }}</div>
        </div>
      </div>
      <div
          id="home-btn"
          class="button"
          @click="handleClickHome"
      >
        {{$t("lang.dashboard")}}
      </div>
    </div>
  </div>
</template>

<script>
import { isPc } from "@/utils";

export default {
  data() {
    return {
      deadline: "2025-06-21T12:00:00+08:00",
      wrapperOpacity: 1,
      timeRemaining: {
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
      },
      headingText: "Stay Tuned.",
    };
  },
  computed: {
    timeBoxes() {
      return [
        { id: "js-clock-days", value: this.timeRemaining.days, label: "Days" },
        { id: "js-clock-hours", value: this.timeRemaining.hours, label: "Hrs" },
        { id: "js-clock-minutes", value: this.timeRemaining.minutes, label: "Min" },
        { id: "js-clock-seconds", value: this.timeRemaining.seconds, label: "Sec" },
      ];
    },
  },
  mounted() {
    this.startClock();
  },
  methods: {
    handleClickHome() {
      if (isPc()) {
        this.routerpush("/account");
      } else {
        this.routerpush("/account-m");
      }
    },
    routerpush(to) {
      this.$router.push(to);
    },
    pad(num, size) {
      return ("0" + num).slice(-size);
    },
    getTimeRemaining(endtime) {
      const now = new Date();
      const endTimeInUTC = new Date(endtime).getTime();
      const t = endTimeInUTC - now.getTime();
      return {
        total: t,
        days: this.pad(Math.floor(t / (1000 * 60 * 60 * 24)), 2),
        hours: this.pad(Math.floor((t / (1000 * 60 * 60)) % 24), 2),
        minutes: this.pad(Math.floor((t / 1000 / 60) % 60), 2),
        seconds: this.pad(Math.floor((t / 1000) % 60), 2),
      };
    },
    startClock() {
      const updateClock = () => {
        const t = this.getTimeRemaining(this.deadline);
        if (t.total <= 0) {
          clearInterval(this.timeInterval);
          this.headingText = "Now is Ready!";
        } else {
          this.timeRemaining = t;
        }
      };
      updateClock();
      this.timeInterval = setInterval(updateClock, 1000);
    },
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
  },
};
</script>

<style lang="less" scoped>
.bk-img {
  background: linear-gradient(120deg, #ff6ec4, #7873f5, #42e695, #ff6ec4);
  background-size: 400% 400%;
  animation: gradientBG 15s ease infinite;
  width: 100vw;
  height: 1000px;
  position: absolute;
  top: -40px;
  left: 0;
  z-index: -100;
  transition: background-image 0.5s ease-in-out;
}

@keyframes gradientBG {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.bk-img::after {
  content: "";
  position: absolute;
  top: 500px;
  left: 0;
  width: 100%;
  height: 50%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);
}

/* 2. 居中布局 */
.countdown-body {
  padding: 24px;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 3. 玻璃拟态+渐变光影 */
.wrapper {
  border-radius: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  inset: 8%;
  box-shadow: 0 8px 40px 8px #f26aff40, 0 0 16px 4px #7d6fff40;
  border: 2px solid rgba(255, 255, 255, 0.18);
  overflow: hidden;
  padding: 48px 24px 80px 24px;
  backdrop-filter: blur(18px);
}

/* 4. 标题渐变+发光 */
.heading {
  text-align: center;
  text-transform: lowercase;
  margin-top: 0;
  margin-bottom: 0;
  font-family: 'Orbitron', 'neue-haas-grotesk-display', monospace;
  font-size: 6vw; /* 缩小字体 */
  line-height: 1.1;
  letter-spacing: 2px;
  filter: drop-shadow(0 0 10px #f26aff80);
  user-select: none;
}

.heading-gradient {
  background: linear-gradient(90deg, #f26aff, #7d6fff, #42e695, #f26aff);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: textGlow 2s infinite alternate, gradientBG 8s linear infinite;
}

@keyframes textGlow {
  0% {
    filter: drop-shadow(0 0 10px #f26aff80);
  }
  100% {
    filter: drop-shadow(0 0 20px #7d6fff80);
  }
}

/* 5. 倒计时盒子：炫彩边框+玻璃+hover光影 */
.js-clock {
  justify-content: center;
  align-items: center;
  font-family: 'Orbitron', 'neue-haas-grotesk-display', monospace;
  display: flex;
  margin: 48px 0 32px 0;
  width: 100%; /* 确保宽度为100%以防止滚动条 */
  overflow-x: hidden; /* 隐藏横向溢出 */
}

.box {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 100px;
  min-height: 110px;
  margin: 0 18px;
  padding: 12px 20px;
  border-radius: 20px;
  background: rgba(30, 30, 60, 0.38);
  border: 3px solid;
  border-image: linear-gradient(120deg, #f26aff, #7d6fff, #42e695) 1;
  box-shadow: 0 4px 32px 0 rgba(125, 111, 255, 0.2), 0 0 8px 2px #f26aff80;
  backdrop-filter: blur(8px);
  transition: transform .2s, box-shadow .2s;
  display: flex;
  cursor: pointer;
  position: relative;
}

.box:hover {
  transform: scale(1.06) rotate(-3deg);
  box-shadow: 0 8px 48px 8px #f26aff80, 0 0 24px 4px #7d6fff80;
}

/* 6. 数字：霓虹发光+跳动动画 */
.clock-number {
  font-family: 'Orbitron', 'neue-haas-grotesk-display', monospace;
  font-size: 80px;
  line-height: 70px;
  color: #fff;
  text-shadow: 0 0 24px #7d6fff, 0 0 48px #f26aff;
  animation: pulse 1.2s infinite alternate;
  letter-spacing: 2px;
  font-weight: bold;
  user-select: none;
}

@keyframes pulse {
  0% {
    text-shadow: 0 0 24px #7d6fff, 0 0 48px #f26aff;
  }
  100% {
    text-shadow: 0 0 48px #f26aff, 0 0 96px #7d6fff;
  }
}

/* 7. 标签 */
.clock-label {
  letter-spacing: 5px;
  text-transform: uppercase;
  margin-top: 10px;
  font-family: 'Orbitron', 'neue-haas-grotesk-display', monospace;
  color: #e5e5ff;
  font-size: 1.1em;
  opacity: 0.8;
  text-shadow: 0 0 6px #7d6fff80;
}

/* 8. 炫彩流光按钮 */
.button {
  color: #fff;
  text-align: center;
  background: linear-gradient(90deg, #f26aff, #7d6fff, #42e695, #f26aff);
  background-size: 200% 200%;
  animation: btnShine 3s linear infinite;
  border-radius: 30px;
  width: 32%;
  margin-left: auto;
  margin-right: auto;
  font-family: 'Orbitron', Open Sans, sans-serif;
  font-size: 28px;
  font-weight: bold;
  box-shadow: 0 0 16px 4px #f26aff80, 0 0 8px 2px #7d6fff80;
  transition: all .2s;
  position: absolute;
  inset: auto 0% 1.5%;
  border: none;
  outline: none;
  cursor: pointer;
  letter-spacing: 2px;
  filter: brightness(1.1);
}

.button:hover {
  filter: brightness(1.3);
  transform: scale(1.04) translateY(-2px);
  box-shadow: 0 0 32px 8px #f26affcc, 0 0 16px 4px #7d6fff80;
}

@keyframes btnShine {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}

/* 9. 响应式优化 */
@media screen and (max-width: 991px) {
  .wrapper {
    inset: 2%;
    padding: 20px 8px 64px 8px;
  }

  .js-clock {
    width: 100%; /* 确保宽度为100%以防止滚动条 */
    flex-wrap: wrap;
    overflow-x: hidden; /* 隐藏横向溢出 */
  }

  .box {
    min-width: 70px;
    min-height: 80px;
    margin: 0 6px;
    padding: 8px;
  }

  .clock-number {
    font-size: 9vw;
  }

  .button {
    width: 40%;
    font-size: 22px;
  }

  .heading {
    font-size: 10vw; /* 再次缩小字体 */
  }
}

@media screen and (max-width: 767px) {
  .wrapper {
    inset: 0;
    padding: 8px 0 56px 0;
  }

  .js-clock {
    margin: 24px 0 24px 0;
    overflow-x: hidden; /* 确保没有横向滚动条 */
  }

  .box {
    min-width: 44px;
    min-height: 44px;
    padding: 4px;
  }

  .clock-number {
    font-size: 10vw; /* 缩小字体 */
  }

  .button {
    width: 60%;
    font-size: 18px;
  }

  .heading {
    font-size: 14vw; /* 缩小字体 */
  }
}

@media screen and (max-width: 479px) {
  .wrapper {
    padding: 0 0 36px 0;
  }

  .js-clock {
    overflow-x: hidden; /* 确保没有横向滚动条 */
  }

  .box {
    width: 20%;
    min-height: 36px;
    margin: 0 2px;
  }

  .clock-number {
    font-size: 10vw; /* 缩小字体 */
  }

  .button {
    width: 90%;
    font-size: 16px;
  }

  .heading {
    font-size: 18vw; /* 缩小字体 */
  }
}

</style>

